"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { forwardRef, Component, createRef } from "react";
import classNames from "classnames";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import { Transition } from "react-transition-group";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import { AnimationDuration } from "../../../styles/Animations";
import forceReflow from "../../../utils/forceReflow";
import { Warning, IconSize } from "../../icons";
import { randomString } from "../../../utils";
import { formatTelephone } from "../../../utils/formatString";
import { Expandable } from "../../behaviors/Expandable";
import Tooltip from "../Tooltip/Tooltip";
import { TooltipSize } from "../Tooltip/Tooltip";
import { TooltipPosition } from "../Tooltip/Tooltip";
import { Label } from "../Label";
import * as styles from "./TextInput-css";
import { Text } from "../Text/Text";
import { darkTheme, lightTheme } from "../../../tokens/tokens-css";
export var TextInputType = /* @__PURE__ */function (TextInputType2) {
  TextInputType2["Text"] = "text";
  TextInputType2["Telephone"] = "tel";
  TextInputType2["Email"] = "email";
  TextInputType2["Password"] = "password";
  TextInputType2["Number"] = "number";
  TextInputType2["Search"] = "search";
  return TextInputType2;
}(TextInputType || {});
export var TextInputVariant = /* @__PURE__ */function (TextInputVariant2) {
  TextInputVariant2["Bordered"] = "bordered";
  TextInputVariant2["Underlined"] = "underlined";
  TextInputVariant2["Borderless"] = "borderless";
  return TextInputVariant2;
}(TextInputVariant || {});
export var TextInputSize = /* @__PURE__ */function (TextInputSize2) {
  TextInputSize2["XSmall"] = "x-small";
  TextInputSize2["Small"] = "small";
  TextInputSize2["Medium"] = "medium";
  TextInputSize2["Large"] = "large";
  return TextInputSize2;
}(TextInputSize || {});
var componentName = "text-input";
var TextInput = /*#__PURE__*/function (_Component) {
  _inherits(TextInput, _Component);
  var _super = _createSuper(TextInput);
  function TextInput() {
    var _this;
    _classCallCheck(this, TextInput);
    _this = _super.apply(this, arguments);
    _this.baseId = _this.props.id || "".concat(componentName, "-").concat(randomString());
    _this.endElementRef = createRef();
    _this.startElementRef = createRef();
    _this.isFocused = false;
    _this.startElementSize = void 0;
    _this.endElementSize = void 0;
    _this.ErrorWrapper = function (_ref) {
      var children = _ref.children;
      var _this$props = _this.props,
        error = _this$props.error,
        errorVariant = _this$props.errorVariant;
      switch (errorVariant) {
        case "bottomTooltip":
          {
            return /* @__PURE__ */React.createElement(Tooltip, {
              content: /* @__PURE__ */React.createElement("div", {
                id: _this.errorId
              }, error),
              size: TooltipSize.Large,
              show: !!error,
              position: TooltipPosition.Bottom,
              autoStack: true,
              isError: true
            }, children);
          }
        default:
          return /* @__PURE__ */React.createElement(React.Fragment, null, children, /* @__PURE__ */React.createElement(Expandable, {
            expanded: !!error,
            timeout: AnimationDuration.Short
          }, function (_ref2) {
            var expandableElementRef = _ref2.expandableElementRef;
            return /* @__PURE__ */React.createElement("div", {
              id: _this.errorId,
              className: styles.error,
              ref: expandableElementRef,
              "aria-live": "polite"
            }, /* @__PURE__ */React.createElement("div", {
              className: styles.errorIcon
            }, /* @__PURE__ */React.createElement(Warning, {
              size: IconSize.Small,
              color: "critical"
            })), /* @__PURE__ */React.createElement(Text, {
              lineHeight: "compact",
              size: "s"
            }, error));
          }));
      }
    };
    _this.onChange = function (event) {
      var _a, _b;
      if (_this.props.type == "tel" /* Telephone */) {
        event.target.value = formatTelephone(event.target.value);
      }
      (_b = (_a = _this.props).onChange) == null ? void 0 : _b.call(_a, event.target.value);
    };
    _this.measureElements = function () {
      var _this$props2 = _this.props,
        startElement = _this$props2.startElement,
        endElement = _this$props2.endElement;
      var getWidth = function getWidth(ref) {
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.getBoundingClientRect().width;
      };
      _this.startElementSize = startElement ? getWidth(_this.startElementRef) : void 0;
      _this.endElementSize = endElement ? getWidth(_this.endElementRef) : void 0;
    };
    _this.handleBlur = function (event) {
      var _a, _b;
      _this.isFocused = false;
      (_b = (_a = _this.props).onBlur) == null ? void 0 : _b.call(_a, event);
    };
    _this.handleFocus = function (event) {
      var _a, _b;
      _this.isFocused = true;
      (_b = (_a = _this.props).onFocus) == null ? void 0 : _b.call(_a, event);
    };
    return _this;
  }
  _createClass(TextInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.measureElements();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.startElement && !this.props.startElement || prevProps.endElement && !this.props.endElement) {
        this.measureElements();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;
      var _a = this.props,
        type = _a.type,
        multiline = _a.multiline,
        label = _a.label,
        placeholder = _a.placeholder,
        value = _a.value,
        variant = _a.variant,
        className = _a.className,
        labelHidden = _a.labelHidden,
        size = _a.size,
        theme = _a.theme,
        innerRef = _a.innerRef,
        error = _a.error,
        errorVariant = _a.errorVariant,
        disabled = _a.disabled,
        onMouseEnter = _a.onMouseEnter,
        onMouseLeave = _a.onMouseLeave,
        onKeyDown = _a.onKeyDown,
        onClick = _a.onClick,
        maxLength = _a.maxLength,
        startElement = _a.startElement,
        endElement = _a.endElement,
        readOnly = _a.readOnly,
        role = _a.role,
        onChange = _a.onChange,
        id = _a.id,
        elementSize = _a.elementSize,
        onFocus = _a.onFocus,
        onBlur = _a.onBlur,
        rest = __objRest(_a, ["type", "multiline", "label", "placeholder", "value", "variant", "className", "labelHidden", "size", "theme", "innerRef", "error", "errorVariant", "disabled", "onMouseEnter", "onMouseLeave", "onKeyDown", "onClick", "maxLength", "startElement", "endElement", "readOnly", "role", "onChange", "id", "elementSize", "onFocus", "onBlur"]);
      var inputId = "".concat(this.baseId, "-input");
      var labelId = "".concat(this.baseId, "-label");
      var elementType = multiline ? "textarea" : "input";
      var InputElement = elementType;
      var isUnderlined = variant === "underlined" /* Underlined */;
      return /* @__PURE__ */React.createElement("div", {
        className: classNames(componentName, styles.container, className, (_classNames = {}, _defineProperty(_classNames, lightTheme, theme === "light"), _defineProperty(_classNames, darkTheme, theme === "dark"), _classNames))
      }, /* @__PURE__ */React.createElement(Label, {
        long: true,
        hidden: labelHidden || isUnderlined,
        disabled: disabled,
        size: size === "x-small" /* XSmall */ ? "s" : "m",
        className: classNames(styles.label, "".concat(componentName, "__label")),
        id: labelId,
        htmlFor: inputId
      }, label), /* @__PURE__ */React.createElement(this.ErrorWrapper, null, /* @__PURE__ */React.createElement("div", {
        className: classNames(styles.inputWrapper({
          size: size
        }), "".concat(componentName, "__input-container"))
      }, /* @__PURE__ */React.createElement(InputElement, __spreadValues({
        className: classNames(styles.input({
          size: size,
          variant: variant
        }), "".concat(componentName, "__").concat(elementType)),
        type: multiline ? void 0 : type,
        ref: innerRef,
        id: inputId,
        "aria-labelledby": labelId,
        "aria-describedby": error ? this.errorId : void 0,
        "aria-multiline": multiline,
        "aria-invalid": !!error,
        placeholder: placeholder,
        onChange: this.onChange,
        value: value,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        disabled: disabled,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onKeyDown: onKeyDown,
        onClick: onClick,
        maxLength: maxLength,
        readOnly: readOnly,
        style: {
          paddingInlineStart: this.startElementSize,
          paddingInlineEnd: this.endElementSize
        },
        role: role,
        size: elementSize
      }, rest)), isUnderlined && /* @__PURE__ */React.createElement(Transition, {
        onEnter: forceReflow,
        in: this.isFocused,
        timeout: AnimationDuration.Medium
      }, function (status) {
        return /* @__PURE__ */React.createElement("div", {
          className: styles.underline({
            focused: ["entering", "entered"].includes(status)
          })
        });
      }), !!startElement && /* @__PURE__ */React.createElement(ReactResizeDetector, {
        handleWidth: true,
        onResize: this.measureElements
      }, /* @__PURE__ */React.createElement("div", {
        ref: this.startElementRef,
        className: classNames(styles.element({
          position: "start"
        }))
      }, startElement)), !!endElement && /* @__PURE__ */React.createElement(ReactResizeDetector, {
        handleWidth: true,
        onResize: this.measureElements
      }, /* @__PURE__ */React.createElement("div", {
        ref: this.endElementRef,
        className: classNames(styles.element({
          position: "end"
        }))
      }, endElement)))));
    }
  }, {
    key: "errorId",
    get: function get() {
      return "".concat(this.baseId, "-error");
    }
  }]);
  return TextInput;
}(Component);
TextInput.defaultProps = {
  type: "text" /* Text */,
  placeholder: "",
  variant: "bordered" /* Bordered */,
  size: "medium" /* Medium */,
  errorVariant: "default"
};
__decorateClass([observable.ref], TextInput.prototype, "isFocused", 2);
__decorateClass([observable.ref], TextInput.prototype, "startElementSize", 2);
__decorateClass([observable.ref], TextInput.prototype, "endElementSize", 2);
__decorateClass([action], TextInput.prototype, "componentDidUpdate", 1);
__decorateClass([action], TextInput.prototype, "measureElements", 2);
__decorateClass([action], TextInput.prototype, "handleBlur", 2);
__decorateClass([action], TextInput.prototype, "handleFocus", 2);
TextInput = __decorateClass([observer], TextInput);
export default forwardRef(function textInput(props, ref) {
  return /* @__PURE__ */React.createElement(TextInput, __spreadValues({
    innerRef: ref
  }, props));
});